import { File } from "../types";
import { getFirst2DFile } from "./getFirst2DFile";
import { has3DFile } from "./has3DFile";

export const is2DPrediction = <T extends Pick<File, "url" | "name" | "createdAt">>(
  files: T[],
): boolean => {
  const has2DFile = !!getFirst2DFile(files);
  const has3DFileResult = has3DFile({ files });

  return has2DFile && !has3DFileResult;
};
